<template>
  <div
    class="bg-white rounded-xl shadow-lg p-4 sm:p-6 hover:shadow-xl transition-all duration-300 border border-gray-100"
    :class="customClass"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    customClass: {
      type: String,
      default: ""
    }
  }
};
</script>
